import { ApiError } from "@crystal/http";
import { SubscriptionError } from "./types.js";
const postWithAkamaiChallenge = async (url, cb, body) => {
  const response = await fetch(url, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "X-Client-Tag": "AccountPortal"
    },
    body: JSON.stringify(body)
  });
  if (response.ok) {
    return await response.json();
  }
  if (response.status === 428) {
    return new Promise((resolve) => {
      const handleChallenge = async () => {
        document.removeEventListener("akamai-challenge-noreload", handleChallenge);
        resolve(cb());
      };
      document.addEventListener("akamai-challenge-noreload", handleChallenge, { once: true });
    });
  }
  const error = await response.json();
  throw new ApiError("Failed to fetch light-account call", error, response.status);
};
async function subscribeUser(subscriptionPayload) {
  try {
    const result = await postWithAkamaiChallenge(
      "/ap-subscription",
      () => subscribeUser(subscriptionPayload),
      subscriptionPayload
    );
    return result;
  } catch (err) {
    const _err = err;
    const error = new SubscriptionError(err, {
      details: (_err == null ? void 0 : _err.details) ?? err
    });
    return Promise.reject(error.serialize());
  }
}
const subscriptionApi = { subscribeUser };
export {
  subscriptionApi
};
//# sourceMappingURL=api-subscription.js.map
